/* eslint-disable camelcase */

import railsService, { applyCsrfInterceptors } from '@/utils/AxiosService'
import { applyFingerprintInterceptor } from '@/utils/fingerprintInterceptor.js'

const getApi = (options = {}) => {
  const api = railsService.create({})
  api.defaults.timeout = 10000

  // axios 0.24's `create()` forks a fresh `new Axios(...)`: this instance
  // inherits `railsService`'s config (`baseURL`, `withCredentials`) but none of
  // its interceptors. Without these calls the fork would neither capture the
  // CSRF token off its responses nor attach it to a write (PLT-2103), and would
  // send no `X-Fingerprint` at all (PLT-2288) — silent blind spots on every
  // request made through it, and a trap for the next one added here.
  return applyFingerprintInterceptor(applyCsrfInterceptors(api))
}

// gets all the contractors (along with the quotes that might have already been submitted)
export const getReportContractorRecommendations = ({ report_id }) => {
  return getApi().get('/api/v1/public/report_contractors', {
    params: { report_id },
  })
}

// --------------------------------------------------
// --------------------------------------------------
// POST
// --------------------------------------------------
// --------------------------------------------------

export const postContractorLead = (params) => {
  return railsService.post('/api/v1/public/contractor_leads', {
    report_view: params.report_view,
    upsell_lead: params.upsell_lead,
  })
}
